import { from, tap } from 'rxjs';
import { withProps, signalStore } from '@ngrx/signals';
import { rxResource } from '@angular/core/rxjs-interop';
import { inject, ErrorHandler } from '@angular/core';

export const landingCriticalPreloadStore = signalStore(
  { providedIn: 'root' },
  withProps((_, errorHandler = inject(ErrorHandler)) => ({
    criticalPreload: rxResource({
      stream: () =>
        from(import('@ws-moofyvip/moofyvip-ui-dashboard')).pipe(
          tap({
            error: (error: unknown) => {
              const message =
                error instanceof Error ? error.message : String(error);
              errorHandler.handleError(
                new Error(
                  `Critical preload failed for landing orders path. ${message}`,
                ),
              );
            },
          }),
        ),
    }),
  })),
);
